import { LOGO_URL, RESIZED_LOGO_URL } from '../constants/BusinessUnit';
import { getBusinessUnitDisplayNameByPrimaryBrand } from '../utils/String';
import { usePrimaryBrandId } from '../hooks/usePrimaryBrandId';
import withDeferredRender from './withDeferredRender';
import { AvatarDisplay } from 'avatar-components/AvatarDisplay';
import { AvatarTag as AvatarTagComponent } from 'avatar-components/AvatarTag';
import { jsx as _jsx } from "react/jsx-runtime";
const Avatar = ({
  buLogo,
  truncateLength,
  onlyLogo,
  displayName,
  size
}) => /*#__PURE__*/_jsx(AvatarDisplay, {
  size: size,
  "data-test-id": "business-unit-tag",
  type: "contact",
  src: buLogo,
  childTruncateLength: truncateLength,
  children: !onlyLogo && displayName
});
const AvatarTag = ({
  buLogo,
  displayName
}) => /*#__PURE__*/_jsx(AvatarTagComponent, {
  "data-test-id": "business-unit-tag",
  type: "contact",
  src: buLogo,
  displayName: displayName,
  children: displayName
});
const BusinessUnitTag = ({
  buId,
  buOptions,
  noBorder = false,
  onlyLogo = false,
  truncateLength,
  deferRender = false,
  numFramesToDefer = 2,
  size = 'sm'
}) => {
  const {
    primaryBrandId,
    loading: primaryBrandLoading
  } = usePrimaryBrandId();
  const currentBusinessUnit = (buOptions || []).find(({
    id
  }) => id === buId);
  if (!currentBusinessUnit) {
    console.warn('No valid business unit selected', {
      buId,
      buOptions
    });
    return null;
  }
  let buLogo = currentBusinessUnit[RESIZED_LOGO_URL];
  if (!buLogo) {
    buLogo = currentBusinessUnit[LOGO_URL];
  }
  const displayName = primaryBrandLoading ? currentBusinessUnit.name : getBusinessUnitDisplayNameByPrimaryBrand(currentBusinessUnit.name, currentBusinessUnit.id, primaryBrandId);
  if (noBorder || onlyLogo) {
    if (buLogo) {
      let AvatarComp = Avatar;
      if (deferRender) {
        AvatarComp = withDeferredRender(Avatar, {
          Skeleton: () => /*#__PURE__*/_jsx(AvatarDisplay, {
            "data-test-id": "business-unit-tag",
            type: "contact",
            size: size,
            displayName: displayName,
            children: !onlyLogo && displayName
          })
        });
      }
      return /*#__PURE__*/_jsx(AvatarComp, {
        buLogo: buLogo,
        truncateLength: truncateLength,
        onlyLogo: onlyLogo,
        displayName: displayName,
        numFramesToDefer: numFramesToDefer,
        size: size
      });
    }
    return /*#__PURE__*/_jsx(AvatarDisplay, {
      "data-test-id": "business-unit-tag",
      type: "contact",
      childTruncateLength: truncateLength,
      size: size,
      displayName: displayName,
      children: !onlyLogo && displayName
    });
  }
  if (buLogo) {
    let AvatarTagComp = AvatarTag;
    if (deferRender) {
      AvatarTagComp = withDeferredRender(AvatarTag, {
        Skeleton: () => /*#__PURE__*/_jsx(AvatarTagComponent, {
          "data-test-id": "business-unit-tag",
          type: "contact",
          displayName: displayName,
          children: displayName
        })
      });
    }
    return /*#__PURE__*/_jsx(AvatarTagComp, {
      displayName: displayName,
      buLogo: buLogo,
      numFramesToDefer: numFramesToDefer
    });
  }
  return /*#__PURE__*/_jsx(AvatarTagComponent, {
    "data-test-id": "business-unit-tag",
    type: "contact",
    displayName: displayName,
    children: displayName
  });
};
export default BusinessUnitTag;